import { createRedux } from 'src/firebase';
import { Township } from 'src/store';

const {
  actions,
  actionTypes,
  collectionReducer: townshipsReducer,
  docReducer: townshipDetailReducer,
} = createRedux<Township>('townships');

export {
  actions,
  actionTypes,
  townshipsReducer,
  townshipDetailReducer,
};



// WEBPACK FOOTER //
// ./src/townships/redux.ts